import React from 'react'
import { 
  Modal, 
  ModalHeader,
  ModalBody
} from 'reactstrap'

const Details = ({
  open,
  content,
  onClose,
}) => {
  return (
    <Modal
      isOpen={ open }
      size={ 'md' }>
      <ModalHeader toggle={() => onClose()}>{ `Notification Details` }</ModalHeader>
      <ModalBody>
        <span>{content}</span>
      </ModalBody>
    </Modal>
  )
}

export default Details